import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { mergeClasses } from '@fluentui/react-components';
import {
  Text,
} from '@bingads-webui-react/fabric-control';
import { keyCode } from '@bingads-webui/keycode';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';
import { useStyles } from './style';


const Title = () => {
  const i18n = useContext(I18nContext);
  return (
    <div className="item-title">
      <Text variant="smallPlus" >{i18n.getString(_TL_('Scenes'))}</Text>
      <HelpPopupInline topic="pop_BA_VideoAdsCopilot_Scenes" ariaLabel="Scene selector learn more tooltip" />
    </div>
  );
};

const Scene = ({
  scene, sceneId, onSceneSelected, selectedSceneId, ariaLabel, isHorizontalVideo,
}) => {
  const classes = useStyles();
  const clickFunc = useCallback(() => {
    onSceneSelected({ scene, id: sceneId });
  }, [onSceneSelected, scene, sceneId]);

  const onKeyDown = useCallback((ev) => {
    if (ev.keyCode === keyCode.Enter) {
      clickFunc();
    }
  }, [clickFunc]);

  const {
    keyFrame,
  } = scene;

  const isSelected = sceneId === selectedSceneId;

  return (
    <div className={mergeClasses(classes.sceneItem, 'scene-item')}>
      <div
        className={mergeClasses(isHorizontalVideo ? 'horizontal' : 'vertical', 'scene-decorator')}
        onClick={clickFunc}
        role="tab"
        aria-label={ariaLabel}
        aria-selected={isSelected}
        tabIndex={0}
        onKeyDown={onKeyDown}
      >
        <div className={mergeClasses(classes.sceneThumbnail, 'thumbnail', isSelected ? 'selected' : '')}>
          <img className={classes.sceneThumbnailImage} src={keyFrame.url} alt="scene" />
        </div>
      </div>
      <div className={classes.sceneNumber}>
        <Text variant="medium" >{`${sceneId + 1}`}</Text>
      </div>
    </div>
  );
};

Scene.propTypes = {
  scene: PropTypes.shape({
    keyFrame: PropTypes.shape({}).isRequired,
  }).isRequired,
  onSceneSelected: PropTypes.func.isRequired,
  selectedSceneId: PropTypes.number.isRequired,
  sceneId: PropTypes.number.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  isHorizontalVideo: PropTypes.bool.isRequired,
};

export const ScenePickerView = ({
  scenes, onSceneSelected, selectedSceneId, isHorizontalVideo,
}) => {
  const classes = useStyles();

  return (
    <>
      <Title />
      <div className={mergeClasses(classes.sceneContainer, 'scene-container')} role="tablist">
        {scenes.map(scene => (<Scene
          key={scene.id}
          scene={scene.effective}
          sceneId={scene.id}
          onSceneSelected={onSceneSelected}
          selectedSceneId={selectedSceneId}
          ariaLabel={`Selector for scene ${scene.id + 1}`}
          isHorizontalVideo={isHorizontalVideo}
        />))}
      </div>
    </>
  );
};

ScenePickerView.propTypes = {
  scenes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSceneSelected: PropTypes.func.isRequired,
  selectedSceneId: PropTypes.number.isRequired,
  isHorizontalVideo: PropTypes.bool.isRequired,
};

ScenePickerView.defaultProps = {};
